import { useEffect } from "react";
import { useGameContext } from "GameContext";
import YearReport from "components/Simulation/YearReport";
import React from "react";
import BackButton from "components/BackButton";

import myData from "utils/downloads/GameData.json";

const DataPage: React.FC = () => {
  const {
    refillGameContextFromFile,
  } = useGameContext();

  const rawProposals = [
    {
        "moneyTransfers": [
            {
                "authorId": 55845,
                "amountTransfer": 2000,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Reed Harvester"
            }
        ],
        "faunaActions": [
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 7
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 5
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 7
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 5
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 5
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 7,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 7,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 8,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 8,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            }
        ],
        "mapActions": [
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 5
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 6,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 5,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 1
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 1
                }
            }
        ],
        "muActions": [],
        "changeInHerdEvents": [
            {
                "authordId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstate": "public",
                "quantity": 15
            }
        ],
        "reservationMuActions": []
    },
    {
        "moneyTransfers": [
            {
                "authorId": 55845,
                "amountTransfer": 2000,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Reed Harvester"
            }
        ],
        "faunaActions": [
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 7
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 5
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 7
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 5
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 5
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 7,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 7,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 8,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 8,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            }
        ],
        "mapActions": [
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 5
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 6,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 5,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 1
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 1
                }
            }
        ],
        "muActions": [],
        "changeInHerdEvents": [
            {
                "authordId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstate": "public",
                "quantity": 15
            }
        ],
        "reservationMuActions": []
    },
    {
        "moneyTransfers": [
            {
                "authorId": 55845,
                "amountTransfer": 2000,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Reed Harvester"
            }
        ],
        "faunaActions": [
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 7
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 5
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 7
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 5
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 5
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 7,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 7,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 8,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 8,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            }
        ],
        "mapActions": [
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 5
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 6,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 5,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 1
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 1
                }
            }
        ],
        "muActions": [],
        "changeInHerdEvents": [
            {
                "authordId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstate": "public",
                "quantity": 15
            }
        ],
        "reservationMuActions": []
    },
    {
        "moneyTransfers": [
            {
                "authorId": 55845,
                "amountTransfer": 2000,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Reed Harvester"
            }
        ],
        "faunaActions": [
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 7
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 5
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 7
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 5
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 5
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 7,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 7,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 8,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 8,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            }
        ],
        "mapActions": [
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 5
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 6,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 5,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 1
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 1
                }
            }
        ],
        "muActions": [],
        "changeInHerdEvents": [
            {
                "authordId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstate": "public",
                "quantity": 15
            }
        ],
        "reservationMuActions": []
    },
    {
        "moneyTransfers": [
            {
                "authorId": 55845,
                "amountTransfer": 2000,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Reed Harvester"
            }
        ],
        "faunaActions": [
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 7
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 5
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 7
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 5
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 5
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 7,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 7,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 8,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 8,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            }
        ],
        "mapActions": [
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 5
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 6,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 5,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 1
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 1
                }
            }
        ],
        "muActions": [],
        "changeInHerdEvents": [
            {
                "authordId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstate": "public",
                "quantity": 15
            }
        ],
        "reservationMuActions": []
    },
    {
        "moneyTransfers": [
            {
                "authorId": 55845,
                "amountTransfer": 2000,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Reed Harvester"
            }
        ],
        "faunaActions": [
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 7
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 5
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 7
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 5
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 5
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 7,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 7
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 7,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 8,
                    "y": 6
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 9,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 8,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            }
        ],
        "mapActions": [
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 5
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 6,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 5,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 1
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 1
                }
            }
        ],
        "muActions": [],
        "changeInHerdEvents": [
            {
                "authordId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstate": "public",
                "quantity": 15
            }
        ],
        "reservationMuActions": []
    },
    {
        "moneyTransfers": [
            {
                "authorId": 17220,
                "amountTransfer": 1,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Conservationist"
            },
            {
                "authorId": 55845,
                "amountTransfer": 1000,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Conservationist"
            }
        ],
        "faunaActions": [
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 3
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 3
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            }
        ],
        "mapActions": [
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 0,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 1,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 2,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 0,
                    "y": 6
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 1,
                    "y": 7
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 2,
                    "y": 7
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 3,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 5
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 5,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 6,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 1
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 1
                }
            }
        ],
        "muActions": [],
        "changeInHerdEvents": [
            {
                "authordId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstate": "public",
                "quantity": 15
            }
        ],
        "reservationMuActions": [
            {
                "authorId": 52185,
                "authorRole": "Conservationist",
                "authorEstateClass": "public",
                "actionKind": "create-nature-reserve",
                "managementUnit": 14
            }
        ]
    },
    {
        "moneyTransfers": [
            {
                "authorId": 17220,
                "amountTransfer": 1,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Conservationist"
            },
            {
                "authorId": 55845,
                "amountTransfer": 1000,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Conservationist"
            }
        ],
        "faunaActions": [
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 3
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 3
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            }
        ],
        "mapActions": [
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 0,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 1,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 2,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 0,
                    "y": 6
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 1,
                    "y": 7
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 2,
                    "y": 7
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 3,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 5
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 5,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 6,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 1
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 1
                }
            }
        ],
        "muActions": [],
        "changeInHerdEvents": [
            {
                "authordId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstate": "public",
                "quantity": 15
            }
        ],
        "reservationMuActions": [
            {
                "authorId": 52185,
                "authorRole": "Conservationist",
                "authorEstateClass": "public",
                "actionKind": "create-nature-reserve",
                "managementUnit": 14
            }
        ]
    },
    {
        "moneyTransfers": [
            {
                "authorId": 17220,
                "amountTransfer": 1,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Conservationist"
            },
            {
                "authorId": 55845,
                "amountTransfer": 1000,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Conservationist"
            }
        ],
        "faunaActions": [
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 3
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 3
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            }
        ],
        "mapActions": [
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 0,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 1,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 2,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 0,
                    "y": 6
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 1,
                    "y": 7
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 2,
                    "y": 7
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 3,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 5
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 5,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 6,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 1
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 1
                }
            }
        ],
        "muActions": [],
        "changeInHerdEvents": [
            {
                "authordId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstate": "public",
                "quantity": 15
            }
        ],
        "reservationMuActions": [
            {
                "authorId": 52185,
                "authorRole": "Conservationist",
                "authorEstateClass": "public",
                "actionKind": "create-nature-reserve",
                "managementUnit": 14
            }
        ]
    },
    {
        "moneyTransfers": [
            {
                "authorId": 17220,
                "amountTransfer": 1,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Conservationist"
            },
            {
                "authorId": 55845,
                "amountTransfer": 1000,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Conservationist"
            }
        ],
        "faunaActions": [
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 3
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 3
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            }
        ],
        "mapActions": [
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 0,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 1,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 2,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 0,
                    "y": 6
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 1,
                    "y": 7
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 2,
                    "y": 7
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 3,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 5
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 5,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 6,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 1
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 1
                }
            }
        ],
        "muActions": [],
        "changeInHerdEvents": [
            {
                "authordId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstate": "public",
                "quantity": 15
            }
        ],
        "reservationMuActions": [
            {
                "authorId": 52185,
                "authorRole": "Conservationist",
                "authorEstateClass": "public",
                "actionKind": "create-nature-reserve",
                "managementUnit": 14
            }
        ]
    },
    {
        "moneyTransfers": [
            {
                "authorId": 17220,
                "amountTransfer": 1,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Conservationist"
            },
            {
                "authorId": 55845,
                "amountTransfer": 1000,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Conservationist"
            }
        ],
        "faunaActions": [
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 3
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 3
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            }
        ],
        "mapActions": [
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 0,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 1,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 2,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 0,
                    "y": 6
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 1,
                    "y": 7
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 2,
                    "y": 7
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 3,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 5
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 5,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 6,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 1
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 1
                }
            }
        ],
        "muActions": [],
        "changeInHerdEvents": [
            {
                "authordId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstate": "public",
                "quantity": 15
            }
        ],
        "reservationMuActions": [
            {
                "authorId": 52185,
                "authorRole": "Conservationist",
                "authorEstateClass": "public",
                "actionKind": "create-nature-reserve",
                "managementUnit": 14
            }
        ]
    },
    {
        "moneyTransfers": [
            {
                "authorId": 17220,
                "amountTransfer": 1,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Conservationist"
            },
            {
                "authorId": 55845,
                "amountTransfer": 1000,
                "fromGroupName": "private-Hunter",
                "toGroupName": "public-Conservationist"
            }
        ],
        "faunaActions": [
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 6
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 4
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 0,
                    "y": 0
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 1
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 2,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 1,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 2
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 3,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 4,
                    "y": 3
                },
                "playerId": 17220,
                "playerEstate": "private",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 3
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 3
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 5,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            },
            {
                "faunaName": "DUCK",
                "location": {
                    "x": 6,
                    "y": 0
                },
                "playerId": 97134,
                "playerEstate": "public",
                "playerRole": "Hunter"
            }
        ],
        "mapActions": [
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 0,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 1,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 2,
                    "y": 5
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 0,
                    "y": 6
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 1,
                    "y": 7
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 2,
                    "y": 7
                }
            },
            {
                "authorId": 17220,
                "authorRole": "Hunter",
                "authorEstateClass": "private",
                "actionKind": "clearing",
                "location": {
                    "x": 3,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 9
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 8
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 7
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 6
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 5,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 6,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 7,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 9,
                    "y": 5
                }
            },
            {
                "authorId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstateClass": "public",
                "actionKind": "grazing",
                "location": {
                    "x": 8,
                    "y": 5
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 5,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 6,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 7,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 4
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 3
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 2
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 8,
                    "y": 1
                }
            },
            {
                "authorId": 67060,
                "authorRole": "Reed Harvester",
                "authorEstateClass": "public",
                "actionKind": "cut",
                "location": {
                    "x": 9,
                    "y": 1
                }
            }
        ],
        "muActions": [],
        "changeInHerdEvents": [
            {
                "authordId": 53324,
                "authorRole": "Stockbreeder",
                "authorEstate": "public",
                "quantity": 15
            }
        ],
        "reservationMuActions": [
            {
                "authorId": 52185,
                "authorRole": "Conservationist",
                "authorEstateClass": "public",
                "actionKind": "create-nature-reserve",
                "managementUnit": 14
            }
        ]
    }
  ]

  const rr = rawProposals;//.splice(5, 0) ;//Math.max(rawProposals.length -5, 0))

  console.log(rr);
  const rawData = JSON.parse(myData);

  useEffect(() => {
    refillGameContextFromFile({...rawData, proposalHistory: rr});
  }, [])

  return (
    <div className="h-[100vh] p-20 overflow-auto">
      <YearReport showAllHistory={true} fromDownload={true}/>
    </div>
  )
};

export default DataPage;
